<template>
  <div>
    <div v-if="loading" class="flex justify-center py-12">
      <div class="animate-spin rounded-full h-10 w-10 border-t-4 border-b-4 border-green-500"></div>
    </div>

    <div v-else class="relative overflow-x-auto shadow-md sm:rounded-sm mt-5">
      <div class="flex items-center justify-between px-4 py-2 bg-green-50 border-b border-green-200">
        <div class="flex items-center gap-2">
          <span class="w-2.5 h-2.5 rounded-full bg-green-500 inline-block"></span>
          <h3 class="text-base font-semibold text-green-800">Issued Prescriptions</h3>
        </div>
        <span class="text-xs text-green-600">{{ visits.length }} visit(s)</span>
      </div>

      <table class="w-full text-left text-gray-700">
        <thead>
          <tr class="bg-green-50">
            <th v-for="(h, i) in headers" :key="i" class="px-6 py-3">{{ h }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(visit, index) in paginatedData"
            :key="visit.VisitId"
            class="border-b hover:bg-green-50"
          >
            <td class="px-6 py-2">{{ index + 1 }}</td>
            <td class="px-6 py-2">{{ visit.VisitCode }}</td>
            <td class="px-6 py-2">{{ visit.patient?.unique_code }}</td>
            <td class="px-6 py-2">{{ visit.patient?.FullName }}</td>
            <td class="px-6 py-2">{{ visit.prescriptions[0]?.requested_by?.Username || '—' }}</td>
            <td class="px-6 py-2">{{ formatDate(visit.prescriptions[0]?.created_at) }}</td>
            <td class="px-6 py-2">
              <span class="px-2 py-1 rounded text-xs font-semibold bg-green-100 text-green-800">
                Issued
              </span>
            </td>
            <td class="px-6 py-2">
              <button
                @click="openModal(visit.VisitId)"
                class="bg-gray-600 text-white px-4 py-1 rounded hover:bg-gray-700 text-sm"
              >
                View
              </button>
            </td>
          </tr>
          <tr v-if="visits.length === 0">
            <td :colspan="headers.length" class="px-6 py-8 text-center text-gray-400">
              No fully issued prescriptions yet
            </td>
          </tr>
        </tbody>
      </table>

      <PaginationComponent
        v-model:currentPage="currentPage"
        :totalPages="totalPages"
        @update:currentPage="p => currentPage = p"
      />
    </div>

    <PharmacyQueueModal
      :show="showModal"
      :prescriptionId="selectedVisitId"
      @close="closeModal"
      @refetch="fetchVisits"
    />
  </div>
</template>

<script>
import apiClient from "@/services/api";
import PaginationComponent from "@/components/shared/pagination.vue";
import PharmacyQueueModal from "@/views/modals/PharmacyQueueModal.vue";

export default {
  name: "IssuedPrescriptionsTab",
  components: { PaginationComponent, PharmacyQueueModal },

  data() {
    return {
      visits: [],
      loading: false,
      currentPage: 1,
      itemsPerPage: 10,
      showModal: false,
      selectedVisitId: null,
      headers: ["#", "Visit Code", "Patient Unique Code", "Patient Name", "Prescribed By", "Date", "Status", "Action"],
    };
  },

  computed: {
    totalPages() {
      return Math.ceil(this.visits.length / this.itemsPerPage) || 0;
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.visits.slice(start, start + this.itemsPerPage);
    },
  },

  mounted() {
    this.fetchVisits();
  },

  methods: {
    async fetchVisits() {
      try {
        this.loading = true;
        const response = await apiClient.listIssuedPrescriptions();
        if (response.success) {
          this.visits = response.data.visits;
        } else {
          this.$toast.error("Failed to load issued prescriptions");
        }
      } catch {
        this.$toast.error("Failed to load issued prescriptions");
      } finally {
        this.loading = false;
      }
    },

    formatDate(dateString) {
      if (!dateString) return "—";
      return new Date(dateString).toLocaleString("en-US", {
        year: "numeric", month: "long", day: "numeric",
        hour: "numeric", minute: "numeric", hour12: true,
      });
    },

    openModal(visitId) {
      this.selectedVisitId = visitId;
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.selectedVisitId = null;
    },
  },
};
</script>
